import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/main-logo.svg'


const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "login-page__logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "login-page__info" }, "Государственная налоговая служба при Министерстве финансов Кыргызской Республики", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "login-page__ttl" }, "Мобильный контроль", -1)
const _hoisted_5 = {
  key: 0,
  class: "login-page__error"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  class: "login-page__btn",
  type: "submit"
}, "Войти", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Политика конфиденциальности")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("form", {
      class: "login-page__form",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loginAction && _ctx.loginAction(...args)), ["prevent"]))
    }, [
      (!!_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["login-page__input", {'login-page__input--error': !!_ctx.errorMessage}])
      }, [
        _withDirectives(_createElementVNode("input", {
          placeholder: "Логин",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.credentials.username) = $event))
        }, null, 512), [
          [_vModelText, _ctx.credentials.username]
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["login-page__input", {'login-page__input--error': !!_ctx.errorMessage}])
      }, [
        _withDirectives(_createElementVNode("input", {
          placeholder: "Пароль",
          type: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.credentials.password) = $event))
        }, null, 512), [
          [_vModelText, _ctx.credentials.password]
        ])
      ], 2),
      _hoisted_6,
      _createVNode(_component_router_link, {
        class: "privacy-policy",
        to: { name: 'PrivacyPolicy' }
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ], 32)
  ]))
}